export const STATUS = {
  PAID: 'PAID',
  PAYMENT_DUE: 'PAYMENT_DUE',
  NOT_PAID: 'NOT_PAID',
  POSTED: 'POSTED'
};
